
import React, { useEffect, useState } from 'react';
import { Button, Input, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { WhatsAppOutlined, CopyOutlined } from '@ant-design/icons';
import { clearLocalStorageExceptOne } from '../../../common/Utilities';
import { toast } from 'react-toastify';
import { serverUrl } from '../../../common/Constants';
const SignRemotely = ({ open, close, holderType, applicationId, holderId, name, index }) => {
    const navigate = useNavigate();
    const vehicleDetails = JSON.parse(localStorage.getItem('vehicleDetails'));
    const [toAddress, setToAddress] = useState('');
    // const modalHandler = () => {
    //     navigate('/loan-application');
    //     clearLocalStorageExceptOne("dealerModuleToken");
    // }

    const handleShareOnWhatsApp = () => {
        const textToShare = serverUrl + "remote-sign?holderType=" + holderType + "&applicantionId=" + applicationId + "&holdername=" + name + "&holderId=" + holderId;
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(textToShare)}`;
        window.open(whatsappUrl, '_blank');
    };

    const handleCopyTextToClipboard = () => {
        const textToCopy = serverUrl + "remote-sign?holderType=" + holderType + "&applicantionId=" + applicationId + "&holdername=" + name + "&holderId=" + holderId;
        const tempInput = document.createElement('input');
        tempInput.value = textToCopy;

        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        toast.success("text copied to clipboard");
    };

    const openEmailClient = () => {
        const subject = 'Signature for Applicantion';
        const body = `
        Hello,
        I hope you're doing well!
        I wanted to extend an invitation to you to open the following link and Sign/Upload your Signature:
        `+ serverUrl + "remote-sign?holderType=" + holderType + "&applicantionId=" + applicationId + "&holdername=" + name + "&holderId=" + holderId + `
        Thank you!`;
        const mailtoLink = `mailto:${encodeURIComponent(toAddress)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoLink;
    };

    const handleToAddressChange = (event) => {
        setToAddress(event.target.value);
    };

    return (
        <Modal
            centered
            open={open}
            footer={false}
            onCancel={close}
        >
            <div className='flex m-[0_auto] mb-5'>
                <p className='text-[16px] font-[700]'>Sign Remotely</p>
            </div>
            <div className='m-[0_auto] text-left rounded-lg border border-search-border-color p-3'>
                <p className='text-[13px] font-[400]'>hello,</p>
                <p className='text-[13px] font-[400] mt-5'> Loan application for ({vehicleDetails?.vehicle_reg_no.value}) is ready to be signed.</p>
                <p className='text-[12px] font-[700] mt-5'> {holderType} {index > 0 ? index : ""} ( {name} ) Form Link:</p>
                <p className='text-[12px] font-[400] mt-1 text-[#0660FC]'>{serverUrl + "remote-sign?holderType=" + holderType + "&applicantionId=" + applicationId +"&holdername=" + name+"&holderId=" + holderId}</p>
                <p className='text-[12px] font-[400] mt-5 mb-5'> The links above expires in 7 days if there are no updates to you application case by you or your guarantor(s).</p>
            </div>
            <div>
                <p className='text-[11px] font-[400] mt-2 mb-1'>Share via</p>
                <Button className='bg-green-500 text-white mr-3' onClick={handleShareOnWhatsApp}>
                    <div className='flex'>
                        <WhatsAppOutlined className='mt-1 mr-2' />
                        <span>Whatsapp</span>
                    </div>
                </Button>
                <Button onClick={handleCopyTextToClipboard}>
                    <div className='flex'>
                        <CopyOutlined className='mt-1 mr-2' />
                        <span>Copy Text</span>
                    </div>
                </Button>
                <div className='mt-[35px] flex'>
                    <Input
                        className='mr-[-10px]'
                        type="text"
                        value={toAddress}
                        onChange={handleToAddressChange}
                        placeholder="Enter recipient's email address"
                    />
                    <Button type='primary' onClick={openEmailClient}>Send Email</Button>
                </div>
            </div>
        </Modal >
    );
};
export default SignRemotely;